
function FiscalScorecardController() {

}

module.controller('FiscalScorecardController', FiscalScorecardController)
